import React from 'react';
import styled from 'styled-components';
import { themeColor } from '../theme/colors';

interface ToggleProps {
  value: boolean;
  onToggle: () => void;
  disabled?: boolean;
  id?: string;
  label?: string;
}

export const Toggle: React.FC<ToggleProps> = ({
  value,
  onToggle,
  disabled = false,
  id,
  label,
}) => {
  const handleChange = () => {
    if (!disabled) {
      onToggle();
    }
  };

  return (
    <ToggleWrapper>
      <HiddenCheckbox
        id={id}
        type="checkbox"
        checked={value}
        onChange={handleChange}
        disabled={disabled}
        aria-checked={value ? 'true' : 'false'}
        aria-label={label}
      />
      <StyledToggle
        htmlFor={id}
        value={value}
        disabled={disabled}
        onClick={handleChange}
      >
        <Slider value={value} />
      </StyledToggle>
    </ToggleWrapper>
  );
};

const ToggleWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const HiddenCheckbox = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  clippath: inset(50%);
  height: 1px;
  margin: -1px;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
  overflow: hidden;
`;

const StyledToggle = styled.label<{ value: boolean; disabled?: boolean }>`
  cursor: ${(props) => (props.disabled ? 'initial' : 'pointer')};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  position: relative;
  display: inline-block;
  width: 30px;
  height: 20px;
  border-radius: 15px;
  box-sizing: border-box;
  vertical-align: sub;

  transition: all 0.2s ease;

  background-color: ${(props) =>
    themeColor(props.value ? 'strokePrimary' : '')};

  border: 1px solid
    ${(props) =>
      themeColor(props.value ? 'turquoiseTertiary' : 'strokePrimary')};

  ${HiddenCheckbox}:focus-visible + & {
    outline: 2px solid ${themeColor('turquoise')};
    outline-offset: 2px;
  }
`;

const Slider = styled.div<{ value: boolean }>`
  position: absolute;
  height: 12px;
  width: 12px;
  top: 3px;
  left: 3px;

  ${(props) =>
    props.value &&
    `
     transform: translateX(10px);
    `}
  border-radius: 50%;
  transition: all 0.2s ease;

  background-color: ${(props) =>
    themeColor(props.value ? 'turquoise' : 'strokePrimary')};

  ${(props) =>
    props.value &&
    `
    box-shadow: 0 0 8px 2px rgba(79, 209, 197, 0.4);
  `}
`;
